import React from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Icon } from 'styles';
import ChatMessages from './ChatMessages';
import ChatSuggestions from './ChatSuggestions';

const ChatBody = ({
    messages, loading, suggestions, message, isLimitReached, isDisabled,
    onMessageChange, onSend, creditUsageEnabled, creditCost,
}) => {
    const hasMessages = messages.length > 0;
    const canSend = !loading && !isLimitReached && !isDisabled && (!hasMessages || !!message.trim());

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSend) onSend();
        }
    };

    return (
        <>
            <ChatMessages messages={messages} loading={loading} />

            {!isLimitReached && !isDisabled && (
                <ChatSuggestions suggestions={suggestions} onSelect={onMessageChange} />
            )}

            {isLimitReached && (
                <div className="roxy-panel__limit-reached">
                    Chat message limit reached.
                </div>
            )}

            {!isLimitReached && !isDisabled && (
                <div className="roxy-panel__composer">
                    <textarea
                        className="roxy-panel__input"
                        placeholder={hasMessages ? 'Ask about this application' : 'Start a chat about this application'}
                        value={message}
                        onChange={(e) => onMessageChange(e.target.value)}
                        onKeyDown={handleKeyDown}
                        rows={1}
                    />
                    {!hasMessages && creditUsageEnabled && creditCost > 0 && (
                        <span className="creditCostEndIcon roxy-panel__composer-cost">
                            <span className="creditCostValue">{creditCost}</span>
                            <Icon folder="icons" fileName="credits.svg" />
                        </span>
                    )}
                    <button
                        type="button"
                        className="roxy-panel__send"
                        onClick={onSend}
                        disabled={!canSend}
                        aria-label={hasMessages ? 'Send message' : 'Start chat'}
                    >
                        <ArrowForwardIcon fontSize="small" />
                    </button>
                </div>
            )}
        </>
    );
};

export default ChatBody;
